import React from 'react';
import PropTypes from 'prop-types';

const propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

const WorldIcon = ({ color = '#000', size = 32, ...props }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M12 0c6.614 0 12 5.386 12 12s-5.386 12-12 12S0 18.614 0 12 5.386 0 12 0zm2.919 16.8H9.066c.815 2.6 2.174 3.974 2.934 4.56.747-.6 2.106-1.974 2.919-4.56zm5.401 0h-2.893c-.453 1.72-1.12 3.067-1.814 4.093A9.785 9.785 0 0 0 20.32 16.8zm-13.747 0h-2.88a9.58 9.58 0 0 0 4.68 4.08c-.693-1.026-1.36-2.36-1.8-4.08zm14.72-7.2h-3.426c.08.747.133 1.546.133 2.4 0 .854-.054 1.653-.133 2.4h3.427a9.577 9.577 0 0 0-.001-4.8zm-5.852 0H8.547A19.072 19.072 0 0 0 8.4 12c0 .867.054 1.666.147 2.4h6.894c.093-.734.147-1.533.147-2.4s-.054-1.666-.147-2.4zm-9.307 0H2.706a9.577 9.577 0 0 0 0 4.8h3.428A22.572 22.572 0 0 1 6 12c0-.854.054-1.653.134-2.4zm9.493-6.48c.693 1.026 1.36 2.36 1.8 4.08h2.88a9.58 9.58 0 0 0-4.68-4.08zM12 2.64c-.747.6-2.106 1.974-2.919 4.56h5.853C14.119 4.6 12.761 3.226 12 2.64zm-3.613.466A9.694 9.694 0 0 0 3.693 7.2h2.88c.453-1.72 1.12-3.068 1.813-4.094z"
      fill={color}
      fillRule="evenodd"
    />
  </svg>
);

WorldIcon.propTypes = propTypes;

export default WorldIcon;
